import React, { Component } from "react";
import { Select, Spin } from "antd";
import ScGridTable from "@/components/display/table/gridTableCore";
import { getChanelRank } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";

class Top50Chanel extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      tableConfig: null,
      sortOrder: "-1",
      dataSource: [],
      loading: false,
    };
  }

  componentWillMount() {
    // 预设表单配置项，防止gridTableCore初始化失败
    this.initTableConfig();
    this.handleGetDataSource();
  }

  /** */
  initTableConfig = () => {
    this.setState({
      tableConfig: {
        tableKey: "chargeSuccessTop50ChanelTable",
        tableColumns: [
          {
            name: "排名",
            key: "serial",
            colType: "textCol",
            align: "center",
          },
          {
            name: "渠道",
            key: "appkeyName",
            colType: "textCol",
            align: "center",
          },
          {
            name: "订单总数",
            key: "totalOrder",
            colType: "textCol",
            align: "center",
          },
          {
            name: "成功订单数",
            key: "successOrder",
            colType: "textCol",
            align: "center",
          },
          {
            name: "失败订单数",
            key: "failureOrder",
            colType: "textCol",
            align: "center",
          },
          {
            name: "成功率",
            key: "successRate",
            colType: "textCol",
            align: "center",
            render: (text) => {
              return `${text}%`;
            },
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
        },
        dataApi: this.state.dataSource,
        autoRefresh: false, // 设置为true 直接加载grid数据
      },
    });
  };

  // 升降序改变事件
  sortOrderChange = async (value) => {
    await this.setState({
      sortOrder: value,
    });
    this.handleGetDataSource();
  };

  // 获取数据源
  handleGetDataSource = () => {
    this.setState({
      loading: true,
    });
    fetchHandler(getChanelRank, {
      ...this.props.params,
      topNum: 50,
      sortType: 0,
      sortWay: this.state.sortOrder,
      // startTime: this.props.chooseDate.format(this.getFormatter()),
      // endTime: this.props.chooseDate.format(this.getFormatter()),
      time: this.props.chooseDate.format(this.getFormatter()),
    }).then((res) => {
      if (res && res.code === "success") {
        this.setState(
          {
            dataSource: res.data,
          },
          () => {
            this.initTableConfig();
          },
        );
      }
      this.setState({
        loading: false,
      });
    });
  };

  getFormatter = () => {
    return this.props.timeType === "pickMonth" ? "YYYYMM" : "YYYYMMDD";
  };

  render() {
    // let format = (this.props.timeType === 'pickMonth' ? 'YYYY.MM' : 'YYYY.MM.DD');

    return (
      <Spin spinning={this.state.loading}>
        <div className="section">
          <div className="title-box">
            <div className="title">渠道TOP50</div>
            <div className="search-box">
              <span className="select-label">排序方式：订单总数 </span>
              <Select
                value={this.state.sortOrder}
                onChange={this.sortOrderChange}
                style={{ width: "120px" }}>
                {this.props.sortOrderOptions.map((v) => (
                  <Select.Option value={v.value}>{v.name}</Select.Option>
                ))}
              </Select>
            </div>
          </div>
          <ScGridTable config={this.state.tableConfig} />
        </div>
      </Spin>
    );
  }
}

export default Top50Chanel;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/top50Chanel.js